import {useMutation, useQueryClient} from '@tanstack/react-query';
import contractUpdaters from '@/api/updaters/contracts';

function useCompleteContract() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['contracts', 'complete'],
    mutationFn: contractUpdaters.complete,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
      queryClient.invalidateQueries({queryKey: ['campaignV2CreatorsCounts']});
    },
  });
}

export default useCompleteContract;
